// these files contains services calls
import CONSTANTS from 'libs/backendStringConstants'
import queryString from 'query-string'
import serviceConnect from '../../libs/servicesUtils'

// function to append %20 instead in whitespace instead of + in axios
const paramsSerializer = params => queryString.stringify(params)
const TIMEOUT = 60000

function getDashboardDataService(sitename) {
  const url = `/dashboard`
  if (sitename === CONSTANTS.ALL) {
    return serviceConnect.getService(url, {}, null, TIMEOUT)
  }
  return serviceConnect.getService(
    url,
    {
      sitename
    },
    paramsSerializer,
    TIMEOUT
  )
}

function getDashboardSyncDataService(params) {
  const url = `/dashboard/sync`
  return serviceConnect.getService(url, params)
}

function getHotspotMapData({ sitename }) {
  const url = `/dashboard/hotspot`
  if (sitename === CONSTANTS.ALL) {
    return serviceConnect.getService(url)
  }
  return serviceConnect.getService(
    url,
    {
      sitename
    },
    paramsSerializer
  )
}

function getFullDashboardReportService(params) {
  // const url = `/report`
  const url = '/csv-report'
  return serviceConnect.getService(url, params, null, TIMEOUT * 3)
}

function getDashboardTimeSeries(params) {
  const url = `/dashboard/stats/`
  return serviceConnect.getService(url, params, null, TIMEOUT)
}

function getDashboardDayReport(params) {
  const url = `/csv-report`
  return serviceConnect.getService(url, params, null, TIMEOUT)
}

function getCSVReportStatus() {
  const url = '/csv-report-status'
  return serviceConnect.getService(url, null, null, TIMEOUT * 3)
}

function getCSVDownload() {
  const url = '/csv-download'
  return serviceConnect.getService(url, null, null, TIMEOUT * 3)
}

export default {
  getDashboardDataService,
  getFullDashboardReportService,
  getDashboardTimeSeries,
  getDashboardDayReport,
  getHotspotMapData,
  getCSVReportStatus,
  getCSVDownload,
  getDashboardSyncDataService
}
